import { Modal } from 'src/components/molecules/Modal';
import {
  ModalBoldText,
  ModalList,
  ModalText,
} from './DisableCategoryModal.styles';

interface DisableCategoryModalProps {
  open: boolean;
  setOpen(open: boolean): void;
  onConfirm(): void;
  onCancel(): void;
}

export const DisableCategoryModal = ({
  open,
  setOpen,
  onConfirm,
  onCancel,
}: DisableCategoryModalProps) => {
  return (
    <Modal
      title={'Warning: All configurations turned off'}
      setOpen={setOpen}
      open={open}
      onConfirm={onConfirm}
      onCancel={onCancel}
      size={'medium'}
      data-testid={'disable-category-modal'}
      confirmButtonText="Save"
    >
      <ModalText>
        Turning off configurations will have the following impact
      </ModalText>
      <br />
      <ModalList>
        <ModalBoldText>
          Category will no longer be visible as a determined category in
          Resolution Hub
        </ModalBoldText>
        <ModalBoldText>
          Category will no longer be available for selection by reporters
        </ModalBoldText>
        <ModalBoldText>
          Routing rules that involve this category will be affected
        </ModalBoldText>
      </ModalList>
      <br />
      <ModalText>
        Insights remain unchanged & current reporters will not notice this
        change.
      </ModalText>
    </Modal>
  );
};
